import ArrowDownIcon from "@pages/profile-v2/assets/icons/ArrowDownIcon.jsx";
import CopyIcon from "@pages/profile-v2/assets/icons/CopyIcon.jsx";
import { parseId } from "@pages/profile-v2/utils";
import { copyToClipboard, getCurrencySymbol } from "@utils";
import moment from "moment";
import React, { useState } from "react";
import {
	BonusInfo,
	ButtonText,
	ContentBody,
	ContentFooter,
	ContentHeader,
	ContentWrapper,
	CopyId,
	Date,
	DetailsButton,
	FooterInfoWrapper,
	HeaderTitle,
	Id,
	Note,
} from "./elements";

const PendingWithdrawContent = ({ data, translate, paymentData }) => {
	const [openDetailsIndex, setOpenDetailsIndex] = useState(null);

	const handleDetailsButtonClick = (index) => {
		setOpenDetailsIndex(openDetailsIndex === index ? null : index);
	};

	return data?.reports?.map((report, index) => {
		const areDetailsOpen = openDetailsIndex === index;
		const formattedDate = moment(Number(report?.submissionTime_id?.split("#")[0])).format(
			"YYYY-MM-DD HH:mm"
		);
		const status = report?.status?.split("#")[1];
		const paymentMethod = report?.paymentMethod?.split("#")[1];
		const withdrawAmount = report?.walletContributions?.reduce(
			(acc, cur) => acc + cur.amount.value,
			0
		);
		const isBonus =
			report?.walletContributions?.length > 0 &&
			report?.walletContributions[0]?.walletType !== "Real";
		const note = report?.note || translate("THERE IS NO NOTE");

		return (
			<ContentWrapper key={index}>
				<ContentHeader>
					<Date>{formattedDate}</Date>
					<HeaderTitle status={status}>{status || "-"}</HeaderTitle>
				</ContentHeader>
				<ContentBody>
					{paymentMethod !== "undefined" ? `${paymentMethod} | ` : ""}
					{translate("WITHDRAW")}:{" "}
					{report?.walletContributions && report.walletContributions.length > 0
						? getCurrencySymbol(report.walletContributions[0].amount.currency)
						: ""}{" "}
					{withdrawAmount}
				</ContentBody>
				{areDetailsOpen && (
					<ContentFooter>
						<FooterInfoWrapper>
							<CopyId>
								<CopyIcon
									onClick={() =>
										copyToClipboard(report?.transactionId, translate)
									}
								/>
								{translate("COL-ID")}: <Id>{parseId(report?.transactionId, 7)}</Id>
							</CopyId>
							<BonusInfo>
								{translate("BONUS")}: {isBonus ? "YES" : "NO"}
							</BonusInfo>
						</FooterInfoWrapper>
						<Note>
							{translate("NOTE")}: {note}
						</Note>
					</ContentFooter>
				)}
				<DetailsButton
					rotate={areDetailsOpen}
					onClick={() => handleDetailsButtonClick(index)}>
					<ButtonText>
						{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
					</ButtonText>
					<ArrowDownIcon />
				</DetailsButton>
			</ContentWrapper>
		);
	});
};

export default PendingWithdrawContent;
